import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_MedicalConsent = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_MedicalConsent' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><h3>MEDICAL CONSENT</h3></p>


                <p className='w-750'><h4>Medical Emergency</h4>Staff reviewed the definition of a "Medical Emergency". It was reviewed using a situation that poses an immediate threat to their health or potential health of other. Staff explained that in the event of a "Medical Emergency" steps can be taken to solicit help or assistance immediately.Please see basic Medical Emergency step below.
                </p>

                <table>
                    <tr>
                        <td className='w-750'><b>STEP 1.</b><input type='text' id='txtStep_1' name='txtStep_1' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            Was advised on how to handle emergency situatins and was instructed to take the following steps: First, remain calm.
                            It was explained that although emergencies require rapid actions, the most important factor to consider is that remaining
                            calm is the most effective way to handle a situation and impacts the decision that you are able to make. Remaining calm is
                            the best way to find a safe resolution.</td>
                    </tr>
                </table>

                <p className='w-750'><b>STEP 2.</b><br />
                    Second, They were Instructed to complete and assessment of the situation. Determine the nature of the emergency.What signs indicate that there is an emergency? It's important to stop and take inventory of the situation calmly, before reacting to the emergency.

                </p>

                <p className='w-750'><b>STEP 3.</b><br />
                    Lastly, they were advised on how to complete an assessment of the situation. Determine the nature of the emergency. What signs indicate that there is an emergency? It's important to stop and take
                    inventory of the situation clamly, before reactiong to the emergency.

                </p>

                <p className='w-750'><b>Medication</b><br />
                    They were instructed to continue to take medication as prescribed. The "checked" box next to each specific medication and Dosage is confirmation that client received information on the Risk & Benefits of each specific medication. This process includes medication name, side effects, interactions, warnings, dosage,etc....
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Medication Name</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtMedicationName' name='txtMedicationName' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Side Effects</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtSideEffects' name='txtSideEffects' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Interactions</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtInteractions' name='txtInteractions' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Warnings</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtWarnings' name='txtWarnings' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Dosage</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtDosage' name='txtDosage' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Etc...</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtEtc' name='txtEtc' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                 <p className='w-750'>I &nbsp;
                    <input type='text' id='txt_11' name='txt_11' className='add-only w-200 custom-add-only' />
                   Understand the medication's listed above are necessary and potentially helpful for my mental illness.Off-label
                   medication use (not FDA approved) and black box warnings have been clearly explained to me by the prescribing physician or his/her designee.</p>

                    <table>
                        <tr>
                            <td className='w-750'><span className='eleHeader'>Discontinued Medications:</span>
                            </td>
                        </tr>
                        <tr>
                            <td className='w-250'>1. 
                                <input type='text' id='txtDiscontinuedMedications_1' name='txtDiscontinuedMedications_1' className='add-only w-200 custom-add-only'/>
                                </td>
                            <td className='w-250'>2. 
                                <input type='text' id='txtDiscontinuedMedications_2' name='txtDiscontinuedMedications_2' className='add-only w-200 custom-add-only'/>
                                </td>
                            <td className='w-250'>3. 
                                <input type='text' id='txtDiscontinuedMedications_3' name='txtDiscontinuedMedications_3' className='add-only w-200 custom-add-only'/>
                                </td>
                        </tr>
                    </table>


                <p className='w-750'>I &nbsp;
                    <input type='text' id='txt_11' name='txt_11' className='add-only w-200 custom-add-only' />
                    consent to my individualized medication plan administration and was counseled on the effects/risk/benefits of prescribed medications and was
                    counseled extensively and warned about discontinuing medication without consulting with the doctor. I am also aware that the medication dose may be adjusted over time with the psychiatrist. Individual was
                    encouraged to select a date for a follow up appointment to re-evaluate medications (see date above) .They were advised that in the event of any unusual changes in their health.
                    mood etc. that they should consult the prescribing physician with any questions or concerns. They were informed on how to obtain the prescribing physicians name and contact information from their pill bottles. They were also made aware of their right to revoke consent for medication
                    at any time unless the use fo medications is court ordered.</p>

                <p className='w-750'><b>Written Consent:</b>
                    I attest that I have been advised of the necessary steps to take in the event of a medical emergency. I also attlest that I have been
                    advised of the adverse effects that failing to comply with physicians orders, initial appointment, follow-up visits and referrals to PCP's can be detrimental to my overall health.I have discussed my diagnosis and target symptoms for the medication recommended, the benefits/intended outcome of treatment and
                    possible alternatives. I atlest that I was active participant in the development of my Medical Crisis Plan along with my assigned clinician.</p>


                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Individual Signature</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Guardian Signature (if applicable)</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Witness Signature</td>
                        <td className='small w-250'>Date</td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>MD Signature</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>










            </div>
        </form >

    )
}   